@if (!print) {
    <app-page-header [title]="'Periode'" subtitle="verrekening">
        <app-date-indicator [fromDate]="beginDate" [toDate]="endDate" (next)="next()" (prev)="prev()" indicator />

        <button class="menu-button" (click)="pdf()" print-pdf color="primary" mat-icon-button>
            @if (!downloadingPdf) {
                <mat-icon fontSet="far" fontIcon="fa-file-pdf" />
            }

            @if (downloadingPdf) {
                <mat-spinner />
            }
        </button>
    </app-page-header>
}

@if (user) {
    <div class="wrapper">
        <div class="header">
            <div class="tables">
                <div class="employee-info">
                    @if (!readonly) {
                        <div class="employee">
                            <button (click)="prevEmployee()" color="primary" mat-icon-button>
                                <i class="fas fa-chevron-left"></i>
                            </button>

                            <ng-select
                                [formControl]="fcUserId"
                                [items]="employees"
                                [searchFn]="customSearchFn"
                                [clearable]="false"
                                bindValue="id">
                                <ng-template ng-label-tmp ng-option-tmp let-item="item">
                                    @if (!readonly) {
                                        <small>{{ item.group }} {{ item.afas_employee_id?.padStart(4, '0') }}</small>
                                        {{ item.lastname }}, {{ item.firstname }} {{ item.insertion }}
                                    }

                                    @if (readonly) {
                                        {{ item.name }}
                                    }
                                </ng-template>
                            </ng-select>

                            <button (click)="nextEmployee()" color="primary" mat-icon-button>
                                <i class="fas fa-chevron-right"></i>
                            </button>
                        </div>
                    }

                    @if (readonly) {
                        <div class="employee flex-column align-items-start justify-content-center">
                            <h1 class="mb-1">{{ user.name }}</h1>
                            <span>{{ user.email }}</span>
                            <span>
                                Personeelsnummer <strong>{{ user.afas_employee_id ?? '-' }}</strong>
                            </span>
                        </div>
                    }

                    <div class="basictable">
                        <table>
                            <tr>
                                <td>
                                    Uren
                                    @if (periodType === 'month') {
                                        in {{ beginDate | date: 'MMMM' }} {{ year }}
                                    } @else {
                                        periode {{ period | number: '1.0-0' }} - {{ year }}
                                    }
                                </td>
                            </tr>
                            <tr>
                                <td>
                                    @if (periodType === 'month') {
                                        Uitbetalen in {{ nextMonth | date: 'MMMM' }} {{ year }}
                                    } @else {
                                        Uitbetalen in periode
                                        {{ (period + 1 > 13 ? 1 : period + 1) | number: '1.0-0' }} -
                                        {{ period == 13 ? year + 1 : year }}
                                    }
                                </td>
                            </tr>
                            <tr>
                                <td>
                                    {{ user.function }}

                                    @if (!readonly && environment.shortName === 'DvdS') {
                                        ({{
                                            user.function?.toLowerCase()?.indexOf('asfalt') !== -1
                                                ? 'asfalt '
                                                : 'non-asfalt'
                                        }})
                                    }
                                </td>
                            </tr>
                            <tr>
                                <td>
                                    CAO {{ user.group === 'CHAU' ? 'beroepsgoederenvervoer' : 'Bouw en Infra' }}
                                    @if (environment.roles.Executors | hasRole: user) {
                                        (Uitvoerder)
                                    }
                                </td>
                            </tr>
                        </table>
                    </div>

                    @if (readonly) {
                        <div class="d-flex align-items-center text-center pl-5">
                            <i>Versie: {{ today | date: 'EEEE d MMMM y HH:mm' }}</i>
                        </div>
                    }
                </div>

                @if (!readonly) {
                    <div class="pb-4">
                        @if (screenContent === 'periodeverrekening') {
                            <button
                                class="me-3"
                                mat-raised-button
                                color="primary"
                                routerLink="/boekingsregels/{{ this.user.id }}/{{ period }}/{{ year }}">
                                Boekingsregels
                            </button>
                        }

                        @if (screenContent === 'boekingsregels') {
                            <button
                                mat-raised-button
                                color="primary"
                                routerLink="/periodeverrekening/{{ this.user.id }}/{{ period }}/{{ year }}">
                                Periodeverrekening
                            </button>
                        }
                    </div>
                }
                <div>
                    <div class="basictable contract-days">
                        <table>
                            <tr>
                                <th>Contractdagen</th>
                                <th class="text-right text-nowrap">{{ employeeWorkingHours / 8 }} dagen</th>
                                <th class="text-right text-nowrap">{{ employeeWorkingHours }} uur</th>
                            </tr>
                            @for (dtc of daytypeCounts; track dtc) {
                                <tr>
                                    <td>
                                        {{ dtc.type }}
                                    </td>
                                    <td class="text-right text-nowrap">{{ dtc.count }} dagen</td>
                                    <td class="text-right text-nowrap">{{ dtc.minutes | minutes }} uur</td>
                                </tr>
                            }
                        </table>
                    </div>
                </div>

                @if (readonly) {
                    <img src="/assets/clean-logo.svg" height="85" />
                }
            </div>
        </div>
    </div>
}

@if (user) {
    <div class="content" [class.print]="print">
        @if (screenContent === 'periodeverrekening') {
            <app-period-settlement
                [print]="print"
                [daytypeCounts]="daytypeCounts"
                [beginDate]="beginDate"
                [endDate]="endDate"
                [user]="user"
                (settlingChange)="isSettling($event)" />
        }

        @if (screenContent === 'boekingsregels') {
            <app-settlements-send
                [hideDateSelection]="true"
                [beginDate]="beginDate"
                [endDate]="endDate"
                [user]="user" />
        }
    </div>
}
